module Markdown.Markdown
  ( generateHTMLFromMarkdown
  , sanitisedHTMLFromCommentMarkdown
  , sanitisedHTMLFromContent
  )
  where

import Prelude

import Effect (Effect)
import Hereabout.Types (Comment(..), Content(..), Unsantised(..))

foreign import _generatedHTMLFromMarkdown :: String -> Effect String

generateHTMLFromMarkdown :: String -> Effect String
generateHTMLFromMarkdown = _generatedHTMLFromMarkdown

sanitisedHTMLFromCommentMarkdown :: Comment Unsantised -> Effect (Comment String)
sanitisedHTMLFromCommentMarkdown (Comment comment) = do
  let (Unsantised data') = comment.content
  html <- generateHTMLFromMarkdown data'.data
  pure $ Comment $ comment { content = html}

sanitisedHTMLFromContent :: Content -> Effect Content
sanitisedHTMLFromContent (MarkdownContent str) = do
   html <- generateHTMLFromMarkdown str
   pure $ HTMLContent html
sanitisedHTMLFromContent x = pure x




